export default __webpack_public_path__ + "static/media/step-done-icon.5dbce3e2.svg";